var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillrule: "evenodd",
    cliprule: "evenodd",
    d: "M12 1C5.93455 1 1 5.93438 1 12C1 18.0654 5.93455 23 12 23C18.0655 23 23 18.0654 23 12C23 5.93438 18.0655 1 12 1Z",
    fill: "#27AE60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillrule: "evenodd",
    cliprule: "evenodd",
    d: "M16.7352 8.29789C16.5573 8.10567 16.3185 8 16.0621 8C15.8056 8 15.5665 8.10567 15.3883 8.29846L10.4767 13.613L8.61143 11.5941C8.4335 11.4016 8.19444 11.2959 7.93797 11.2959C7.68149 11.2959 7.44244 11.4019 7.26479 11.5938C6.91178 11.9751 6.91178 12.572 7.26451 12.9527L9.80327 15.7003C9.9812 15.8925 10.2203 15.9984 10.4764 15.9984H10.4767C10.7329 15.9984 10.972 15.8928 11.1505 15.7003L16.7352 9.65738C17.0883 9.27609 17.0883 8.67917 16.7352 8.29789Z",
    fill: "white"
  })));
};

export default __webpack_public_path__ + "static/media/ToastTickIcon.68d6b622.svg";
export { SvgComponent as ReactComponent };